import { BoxProps, ColorOptions, TextProps as TextStyle } from '@jfs/ui-new'
import { Colors } from '../../util/util'

const styles = {
  container: {
    flex: 1,
    width: '100%',
    alignSelf: 'center',
  } as BoxProps,
  mainContainer: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    overflow: 'auto',
    backgroundColor: Colors.JIO_PRIMARY as ColorOptions,
  } as BoxProps,
  formContainer: (isMobileDevice: boolean) =>
    ({
      width: '100%',
      margin: 0,
      paddingBottom: isMobileDevice ? 0 : 10,
    } as BoxProps),
  imgStyle: {
    height: 32,
    // marginTop: 16,
    margin: 0,
    padding: 0,
    underlayColor: 'WHITE',
  } as BoxProps,
  titleStyle: {
    fontSize: 20,
    fontWeight: 'FONT_WEIGHT_BOLD',
    color: 'BLACK',
  } as TextStyle,
  subTitleStyle: {
    fontSize: 12,
    fontWeight: '300',
    marginEnd: 16,
    color: Colors.OTP_GREY as ColorOptions,
    flexWrap: 'wrap',
  } as TextStyle,
  buttonContainer: {
    alignItems: 'center',
    paddingHorizontal: 0,
    paddingTop: 20,
  } as BoxProps,
  errorStyle: { color: 'ERROR', marginLeft: 16 } as TextStyle,
  cardContainer: (isMobile: boolean) =>
    ({
      width: isMobile ? '90%' : undefined,
      minWidth: isMobile ? undefined : 308,
      alignSelf: 'center',
      flex: 1,
      marginTop: isMobile ? 32 : 60,
    } as BoxProps),
  card: {
    backgroundColor: 'WHITE',
    paddingHorizontal: 20,
    shadowColor: Colors.HALF_WHITE as ColorOptions,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.3,
    paddingBottom: 20,
    paddingTop: 16,
    shadowRadius: 4,
    zIndex: 4,
    width: '100%',
    borderRadius: 16,
  } as BoxProps,
  signUpStyle: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 32,
  } as BoxProps,
  dontHaveAccStyle: {
    color: 'WHITE',
    fontSize: 12,
  } as TextStyle,
  signUpText: {
    color: 'WHITE',
    fontSize: 12,
    fontWeight: '400',
  } as TextStyle,
  loginButton: {
    mt: 16,
    borderWidth: 1,
    borderColor: 'WHITE',
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 25,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  scrollView: {
    width: '100%',
  },
  scrollViewContainer: {
    justifyContent: 'center',
  },
}

export { styles }
